import { Controller } from '@hotwired/stimulus'
import AirDatepicker from 'air-datepicker';
import 'air-datepicker/air-datepicker.css';
import localeEn from 'air-datepicker/locale/en';

export default class extends Controller {
  static targets = ['datepickerSingleSelect', 'altField']

  connect() {
    const options = {
      locale: localeEn,
      format: 'MM/dd/yyyy',
      buttons: ['clear'],
      autoClose: true,
      selectedDates: [new Date(this.element.value).toUTCString()],
      onSelect: () => {
        if (this.datepickerSingleSelectTarget.dataset.submitForm === 'true') {
          this.datepickerSingleSelectTarget.form.submit();
        }
      }
    };

    if (this.hasAltFieldTarget) {
      options.altField = this.altFieldTarget;
      options.altFieldDateFormat = 'yyyy-MM-dd';
    }

    this.picker = new AirDatepicker(this.datepickerSingleSelectTarget, options);

    if (this.hasAltFieldTarget) {
      // allow typing into the field.
      this.datepickerSingleSelectTarget.addEventListener('input', this.handleManualInput.bind(this));
    }
  }

  handleManualInput(e) {
    const value = e.target.value;
    const match = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (!match) return;

    const [, month, day, year] = match;
    const date = new Date(year, month - 1, day);

    if (date.getFullYear() === Number(year) && date.getMonth() === Number(month) - 1 && date.getDate() === Number(day)) {
      this.picker.selectDate(date, { silent: true });
    }
  }
}
